export default __webpack_public_path__ + "static/media/oct-22.c8a5d8f7.jpg";